import React from 'react'
import BEMHelper from '@ynap/bem-helper'
import { Button } from '@ynap/button'
import { Link } from 'react-router-dom'
import { Return, Exchange } from '../../../utils/order-status/interfaces'

const bem = new BEMHelper('OrderInformation')

type ReturnsAndExchangesProps = {
    messages: any,
    locale: {
        country: string
        currency: string
        id: string
        langISO: string
        language: string
    }
    returns: Array<Return>,
    exchanges: Array<Exchange>,
    urlPath: string,
    returnTrackingUrl: string,
    guestUser: boolean
}

const ReturnsAndExchanges: React.FC<ReturnsAndExchangesProps> = ({
    messages,
    locale,
    exchanges,
    returns,
    urlPath,
    returnTrackingUrl,
    guestUser,
}) => {

    const hasExchanges = exchanges && exchanges.length >= 1
    const hasReturns = returns && returns.length >= 1

    return (
        <>
           {hasExchanges && (
                <div className={bem('exchanges')}>
                    <h3 className={bem('exchangesReturnsTitle')}>{messages.orderDetails.createdExchangesTitle()}</h3>
                    <p className={bem('exchangesReturnsInfo')}>{messages.orderDetails.createdExchangesInfo()}</p>

                    <p className={bem('yourExchangeInfo')}>{messages.orderDetails.yourExchangesInfo()}</p>
                    {exchanges.map((exchange: Exchange) =>
                        exchange?.exchangeIdentifier && !guestUser ? (
                            <Button
                                key={exchange.exchangeIdentifier}
                                type="primary-link"
                                component={Link}
                                className={bem('exchangeIdentifier')}
                                to={`/${locale.id}/account/${urlPath}/${exchange.exchangeIdentifier}`}
                            >
                                {exchange.exchangeIdentifier}
                            </Button>
                        ) : (
                            exchange?.exchangeIdentifier
                        )
                    )}
                    {returnTrackingUrl && (
                        <Button
                            type="secondary"
                            component="a"
                            href={returnTrackingUrl}
                            target="_blank"
                            className={bem('trackExchange')}
                        >
                            {messages.orderDetails.trackExchange?.()}
                        </Button>
                    )}
                </div>
            )}
            {hasReturns && (
                <div className={bem('returns')}>
                    <h3 className={bem('exchangesReturnsTitle')}>{messages.orderDetails.createdReturnsTitle()}</h3>
                    <p className={bem('exchangesReturnsInfo')}>{messages.orderDetails.createdReturnsInfo()}</p>
                    {returnTrackingUrl && (
                        <Button
                            type="secondary"
                            component="a"
                            href={returnTrackingUrl}
                            target="_blank"
                            className={bem('trackReturn')}
                        >
                            {messages.orderDetails.trackReturn()}
                        </Button>
                    )}
                </div>
            )}

        </>
    )
}

export default ReturnsAndExchanges